import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  DELETE_BUTTON: `${cleanedFilename(__filename)}-delete-button`,
};
